import { IconDeviceDesktop, IconMoon, IconSun } from '@tabler/icons-react'

import type { ThemeChoice } from '../lib/theme'

const options: Array<{ value: ThemeChoice; label: string; Icon: typeof IconSun }> = [
  { value: 'light', label: 'Terang', Icon: IconSun },
  { value: 'dark', label: 'Gelap', Icon: IconMoon },
  { value: 'system', label: 'Ikut sistem', Icon: IconDeviceDesktop },
]

/**
 * Pemilih tema terang, gelap, atau ikut sistem. Pilihannya disimpan di
 * localStorage lewat modul tema, dan tema yang tersimpan sudah dipasang sebelum
 * render oleh /theme.js.
 */
export function ThemeSwitch({
  choice,
  resolved,
  onChange,
}: {
  choice: ThemeChoice
  resolved: 'light' | 'dark'
  onChange: (choice: ThemeChoice) => void
}) {
  return (
    <div className="theme-switch" role="group" aria-label="Pilihan tema">
      {options.map(({ value, label, Icon }) => (
        <button
          key={value}
          type="button"
          className="theme-switch__btn"
          aria-pressed={choice === value}
          title={`Tema ${label}`}
          onClick={() => onChange(value)}
        >
          <Icon size={18} stroke={1.75} aria-hidden="true" />
          <span className="visually-hidden">
            {label}
            {choice === value ? ' (dipilih)' : ''}
          </span>
        </button>
      ))}
      <span className="visually-hidden" role="status">
        Tema yang berlaku: {resolved === 'dark' ? 'gelap' : 'terang'}
      </span>
    </div>
  )
}
